import completeProfile from './fr/completeProfile.fr';
export default {
  ...completeProfile,
};
